<script>
import { reactive } from "vue";
import Form from './components/Form.vue';

export default {
    components: {
        Form,
    },
    
}
</script>

<template>
    <Form></Form>
</template>